import React, { useEffect, useState } from "react";
import * as S from "./ResueltasList.style";
import * as P from "../../../../../../../../../utils/pipes";
import FlorenzButton from "../../../../../../../../florenzComponents/florenzButton";
import { QUERY_GET_USER_TO_BARRIERS_FILTERS } from "../../../../../../../../../graphql/mutations/Barriers";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

const mockResueltas = [
  { id: 1, phase: 'Fase 4', name: 'Jullietta Lopez', barrier: 'Barrera Física', img: 'https://i.pravatar.cc/150?img=10', dateReported: '15 de octubre de 2025', dateExpected: '11 Dic 2025', isExpectedDelayed: true, dateResolved: '30 Dic 2025' },
  { id: 2, phase: 'Fase 5', name: 'Marcus Chen', barrier: 'Barrera de Información', img: 'https://i.pravatar.cc/150?img=11', dateReported: '22 de octubre de 2025', dateExpected: '15 Dic 2025', isExpectedDelayed: false, dateResolved: '5 Dic 2025' },
  { id: 3, phase: 'Fase 6', name: 'Sofia Patel', barrier: 'Barrera psicosocial', img: 'https://i.pravatar.cc/150?img=12', dateReported: '3 de octubre de 2025', dateExpected: '20 Feb 2025', isExpectedDelayed: false, dateResolved: '10 Feb 2025' },
  { id: 4, phase: 'Fase 7', name: 'David Kim', barrier: 'Barrera Social Familiar', img: 'https://i.pravatar.cc/150?img=13', dateReported: '10 de octubre de 2025', dateExpected: '22 Dic 2025', isExpectedDelayed: false, dateResolved: '22 Dic 2025' },
  { id: 5, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 6, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 7, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 8, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 9, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 10, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 11, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 12, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
  { id: 13, phase: 'Fase 8', name: 'Elena Gonzalez', barrier: 'Barrera Profesional / Ocu...', img: 'https://i.pravatar.cc/150?img=14', dateReported: '28 de octubre de 2025', dateExpected: '30 Nov 2025', isExpectedDelayed: true, dateResolved: '11 Dic 2025' },
];

const ResueltasList = ({ 
  filterProgram,
  inputText,
  onOpenReport
}) => {
  const {t, i18n: { language }} = useTranslation("global");
  const loadLimit = 20; 
  const [offset, setOffset] = useState(0);
  const [barriersList, setBarriersList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const where = {
    barrierStatus: { _eq: "completed" }
  }

  if (filterProgram !== null && filterProgram !== undefined) {
    where.processId = { _eq: filterProgram };
  }

  if (inputText && inputText.trim() !== "") {
    const terms = inputText.trim().split(/\s+/);

    where._and = terms.map(term => ({
      _or: [
        { user: { name: { _ilike: `%${term}%` } } },
        { user: { lastname: { _ilike: `%${term}%` } } },
        { user: { email: { _ilike: `%${term}%` } } },
        { user: { documentNumber: { _ilike: `%${term}%` } } },
      ]
    }));
  }

  const { data: userToBarriers, loading: userToBarriersLoading, error: userToBarriersError, fetchMore } = useQuery(
    QUERY_GET_USER_TO_BARRIERS_FILTERS, 
    { 
      variables: { 
        where,
        limit: loadLimit, 
        offset: 0
      },
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true
    },
  ); 
  
  console.log("barriers: ", userToBarriers);
  console.log("userToBarriersError: ", userToBarriersError);
  

  useEffect(() => {
    if (userToBarriersLoading) return;
    if (userToBarriers?.userToBarrier) {
      setBarriersList(userToBarriers.userToBarrier);
      setOffset(userToBarriers.userToBarrier.length);
      
      if (userToBarriers.userToBarrier.length <= loadLimit) {
        setHasMore(userToBarriers.userToBarrier.length === loadLimit);
      }
    }
  }, [userToBarriersLoading, userToBarriers]);
  
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore && !userToBarriersLoading && !isFetchingMore) {
      setIsFetchingMore(true);
      fetchMore({
        variables: {
          limit: loadLimit,
          offset: offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult || fetchMoreResult.userToProcess.length === 0) {
            return prev;
          }

          const existingIds = new Set(prev.userToProcess.map(p => p.id));
          const newItems = fetchMoreResult.userToProcess.filter(p => !existingIds.has(p.id));

          return {
            ...prev,
            userToProcess: [...prev.userToProcess, ...newItems]
          };
        }
      }).then(({ data }) => {
        if (!data || !data.userToProcess || data.userToProcess.length < loadLimit) {
          setHasMore(false);
        }
        setIsFetchingMore(false);
      }).catch(() => {
        setIsFetchingMore(false);
      });
    }
  };

  return (
    <S.ResueltasTable>
      <div className="table-header">
        <div className="th-item">Nombre del paciente</div>
        <div className="th-item">Fecha de reporte</div>
        <div className="th-item">Cuando debía resolverse</div>
        <div className="th-item">Cuando se resolvió</div>
        <div className="th-item th-actions">Acciones rápidas</div>
      </div>
      <div 
        className="table-body"
        onScroll={handleScroll}
      >
        {barriersList.map((item) => (
          <div className="table-row" key={item.id}>
            <div className="col-patient">
              <img src={item.user?.picture} alt={item.user.name + " " + item.user.lastname} className="avatar" />
              <div className="info-group">
                {/* <span className="phase">{item.processId}</span> */}
                <span className="name">{item.user.name + " " + item.user.lastname}</span>
                <span className="barrier">{P.dataTranslation(item?.subTypeBarrier?.typeBarrier?.name, language)}</span>
              </div>
            </div>
            <div className="col-date-rep">
              {P.longDate(item.created_at, t, language)}
            </div>
            <div className="col-date-exp">
              <span className={`icon-date ${item.isExpectedDelayed ? 'delayed' : 'ontime'}`}>
                <i className="icon-date zaia-i-birth"></i>
              </span>
              <span>{P.longDate(item.estimatedSolutionDate, t, language)}</span>
            </div>
            <div className="col-date-res">
              {P.longDate(item.solutionDate, t, language)}
            </div>
            <div className="col-actions">
              <div className="ver-reporte">
                <FlorenzButton
                  size="s"
                  typeStyle={"outline"}
                  text={"Ver reporte"}
                  widthComplete={true}
                  onClick={() => onOpenReport && onOpenReport(item)}
                />
              </div>
            </div>
          </div>
        ))}
        <div className="eso-es-todo">
          Eso es todo
        </div>
      </div>
    </S.ResueltasTable>
  );
};

export default ResueltasList;
